import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { axios_instance } from "../../../api/axios_instance";
import { formatAmount } from "../../../utils/format";
import ModalWrapper from "../../../layouts/ModalWrapper";

const ConfirmationModal = ({
  withheldCheckboxes,
  fetchListData,
  visibilityObj,
  closeConfirmationModal,
  showConfirmationModal,
  setWithHeldCheckboxes,
  setIsLoading,
}) => {
  const [state, setState] = useState({ confirmationData: [] });
  const ref = useRef();

  useEffect(() => {
    return modalEventListener(ref, closeConfirmationModal);
  }, [closeConfirmationModal]);

  const fetchData = async () => {
    try {
      const result = await axios_instance({
        url: "/wp/getConfirmationModalData",
        method: "POST",
        data: {
          checkboxes: withheldCheckboxes,
          action: "wh_confirmation",
        },
      });
      if (result.status === 200) {
        setState((prevState) => ({
          ...prevState,
          confirmationData: result.data.confirmationData,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (showConfirmationModal) fetchData();
  }, [showConfirmationModal]);

  const submitCases = async () => {
    try {
      const response = await axios_instance({
        url: "/wp/submitCases",
        method: "POST",
        data: {
          checkboxes: withheldCheckboxes,
          type: "submit",
          stage: visibilityObj.withheldStage,
          sub_stage: visibilityObj.withheldSubstage,
          action: "submit_cases",
        },
      });

      if (response.status === 200) {
        setWithHeldCheckboxes(() => ({}));

        setIsLoading(true);
        closeConfirmationModal();

        setTimeout(async () => {
          await fetchListData(false, false, false, true);
        }, 10000);
      }
    } catch (error) {}
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showConfirmationModal} onClose={closeConfirmationModal}>
      <div className="modal-wrapper">
        <div className="confirmation-modal-content" ref={ref}>
          <div className="modal-header">
            <button
              type="button"
              className="close"
              onClick={closeConfirmationModal}
            >
              <span>&times;</span>
            </button>
            <h4 className="modal-title" id="">
              Confirmation
            </h4>
            <div className="p-4 bg-gray-100 border-b text-sm text-gray-700">
              <span>
                <strong>Note:</strong> Cases in{" "}
                <span className="col-red bold">Red</span> denote mismatch in RTO
                charges in TU, TitleBox, and PaymentBox. Get the TU updated.
              </span>
            </div>
          </div>

          <div className="modal-body clearfix">
            <div className="tableBox">
              <table className="table table-striped table-hover table-bordered">
                <thead className="thead-default">
                  <tr>
                    <th>Loan ID</th>
                    <th>Car Details</th>
                    <th>Customer Name</th>
                    <th>City</th>
                    <th>Balance Amount</th>
                    <th>Withheld Amount</th>
                    <th>Actual Charges</th>
                    <th>Tranche Amount</th>
                  </tr>
                </thead>
                <tbody id="confirmation_body">
                  {state.confirmationData.map((data, idx) => {
                    return (
                      <tr
                        key={idx}
                        style={{ color: data.isMismatch ? "red" : "" }}
                      >
                        <td>{data.finance_lead_id}</td>
                        <td>{data.regno}</td>
                        <td>{`${data.customer_name} ${data.last_name}`}</td>
                        <td>{data.lead_city}</td>
                        <td>{formatAmount(+data.dts_bal_amt)}</td>
                        <td>{formatAmount(+data.withheldRtoAmount)}</td>
                        <td>{formatAmount(+data.final_rto_charge)}</td>
                        <td>{formatAmount(+data.trancheAmount)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer text-center">
            <button
              type="button"
              className="btn rc-btn_rset pad-L20 pad-R20"
              onClick={closeConfirmationModal}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn rc-btn_primary btn-lg"
              onClick={submitCases}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default ConfirmationModal;
